import { hostFactory as hostInstance } from "../factory";

const getRoles = () => hostInstance.get("/api/roles");

const getRoleById = id => hostInstance.get(`/api/roles/${id}`);

const deleteRole = id => hostInstance.delete(`/api/roles/${id}`);

export { getRoleById, deleteRole };

export default getRoles;
